<template>
  <div class="search-page">
    <h1>Search</h1>
    <form @submit.prevent="submitBooking">
      <div class="form-group">
        <label for="destination">Destination:</label>
        <input type="text" id="destination" v-model="booking.destination" required />
      </div>
      <div class="form-group">
        <label for="departure">Departure Date:</label>
        <input type="date" id="departure" v-model="booking.departureDate" required />
      </div>
      <div class="form-group">
        <label for="return">Return Date:</label>
        <input type="date" id="return" v-model="booking.returnDate" required />
      </div>
      <div class="form-group">
        <label for="travelers">Number of Travelers:</label>
        <input type="number" id="travelers" v-model="booking.travelers" min="1" required />
      </div>
      <button type="submit">Book Travel</button>
    </form>
  </div>
</template>

<script>
export default {
  name: 'Search',
  data() {
    return {
      booking: {
        destination: '',
        departureDate: '',
        returnDate: '',
        travelers: 1
      }
    };
  },
  methods: {
    submitBooking() {
      // Handle form submission logic, e.g., API call
      console.log('Booking submitted:', this.booking);
    }
  }
};
</script>

<style scoped>
.search-page {
  padding: 20px;
  text-align: center;
  background-color: v-bind($store.state.theme === 'dark' ? '#333' : '#f7f7f7');
  color: v-bind($store.state.theme === 'dark' ? '#fff' : '#333');
}
form {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.form-group {
  margin-bottom: 15px;
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
}
label {
  margin-bottom: 5px;
  font-weight: bold;
}
input {
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  transition: border-color 0.3s;
  width: 100%;
  box-sizing: border-box;
}
input:hover {
  border-color: #007bff;
}
input:focus {
  border-color: #0056b3;
  outline: none;
}
button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: background-color 0.3s;
}
button:hover {
  background-color: #0056b3;
}
@media (max-width: 600px) {
  .form-group {
    width: 90%;
  }
}
</style>